export function buildQuery (conditions) {
  const query = conditions.map((c) => {
    if (!c['column']) {
      return ''
    }
    const value = buildQueryValue(c)
    return (c['column'] + ' ' + c['equality'].toUpperCase() + ' ' + value)
  }).join(' AND ')

  return query
}

function buildQueryValue (condition) {
  const value = condition['value']
  if (['like', 'not_like'].includes(condition['equality'])) {
    return `"%${value}%"`
  } else if (['empty', 'not_empty', 'me', 'current_user'].includes(condition['equality'])) {
    return ''
  }

  return `"${value}"`
}
